import * as Yup from 'yup';

const ChangePasswordValidationSchema = Yup.object().shape({
    'sso': Yup.boolean()
        .required('Single Sign On Agreement acceptance is required')
        .oneOf([true], 'Single Sign On Agreement acceptance is required'),
    'terms': Yup.boolean()
        .required('Terms of Use acceptance is required')
        .oneOf([true], 'Terms of Use acceptance is required'),

});

export default ChangePasswordValidationSchema;
